export const nextBusinessDay = date => {
  if (date.isoWeekday() > 5) {
    date.add(8 % date.isoWeekday(), 'days')
  }
  return date
}

export const url = {
  format: url => {
    if (!url) return ''
    return url.substr(0, 'http'.length) !== 'http' ? 'http://' + url : url
  },
}
